<template>
<div  class="home-wrap" ref="homeWrapContainer">
    <div class="home" ref="home">
        <Header class="app-header"></Header>
        <div >
        <!-- go车惠 -->
        <div class="go-cat">
            <TitleNav :left="'Go车惠'" :path="'/gocat'" />
            <Banner :data="GOData" :path="'/enquiry'" />
            <List :data="GOData" :path="'/enquiry'" />
        </div>
        <!-- 新闻资讯 -->
        <div class="news">
            <TitleNav :left="'新闻资讯'" :path="'/news'" />
            <Banner :data="NewsData" :path="'/newsDetails'" />
            <List :data="NewsData" :path="'/newsDetails'" />
        </div>
        <!-- 试驾测评 -->
        <div class="test-drive">
            <TitleNav :left="'试驾测评'" :path="'/testdrive'" />
            <Banner :data="TestData" :path="'/newsDetails'" />
            <List :data="TestData" :path="'/newsDetails'" />
        </div>
        <!-- 往期回顾 -->
        <div class="review">
            <TitleNav :left="'往期回顾'" :path="'/review'" />
            <Banner :data="ReviewData" :path="'/newsDetails'" />
            <List :data="ReviewData" :path="'/newsDetails'" />
        </div>
        <!-- 诚信商家 -->
        <!-- <div class="honest-man">
            <TitleNav :left="'诚信商家'" :path="'/honest'" />
            <div class="merchants-wrap">
                <div class="merchants" v-for="(item,index) in merchants" :key="index">
                    <div class="img-wrap" :data-id="item.id">
                        <img :src="item.acater" alt="">
                    </div>
                    <div class="merchants-text">
                        <div class="datailsWrap">
                            <div class="honesDetailsItem">
                                <span>商家：</span>
                                <span>{{item.username}}</span>
                            </div>

                            <div class="honesDetailsItem">
                                <span>地址：</span>
                                <span>{{item.area}}</span>
                            </div>
                            <div class="honesDetailsItem">
                                <span>电话：</span>
                                <span>{{item.tell}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div> -->
        </div>
        <Footer class="app-footer"></Footer>
    </div>
</div>
</template>

<script>
import BScroll from 'better-scroll';
import TitleNav from '@/components/TitleNav/TitleNav';
import Banner from '@/components/Banner/Banner';
import Footer from '@/components/Footer/Footer';
import Header from '@/components/Header/Header';

import List from '@/components/List/List';
import _ from 'lodash';
export default {
    name: 'Home',
    components: {
        TitleNav,
        Banner,
        List,
        Footer,
        Header
    },
    data() {
        return {

            merchants: [],

            GOData: [],
            NewsData: [],
            TestData: [],
            ReviewData: []
        }
    },
    async created() {
        this.getNewsIndexList();
        this.getActionList();
        this.getNewsPrevious();
        // this.getUserIndexList();

        // setTimeout(() => {

        //     this.$nextTick(() => {
        //         if (this.scroll) {
        //             this.scroll.refresh();
        //         } else {
        //             this.scroll = new BScroll(this.$refs.homeWrapContainer, {
        //                 scrollY: true,
        //                 click: true,
        //                 mouseWheel: true, //开启鼠标滚轮
        //                 disableMouse: false, //启用鼠标拖动
        //                 disableTouch: false //启用手指触摸
        //             })
        //         }

        //     })
        // }, 2000)

    },
    mounted() {

    },
    methods: {
        async getNewsIndexList() {
            const result = await this.$http.home.getNewsIndexList({
                pageSize: 4
            })
            if (result.code === 200) {

                this.NewsData = result.data.news_car;
                this.TestData = result.data.shijia;

            } else {
                this.$message({
                    message: '暂无数据。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },
        async getActionList() {
            const result = await this.$http.home.getActionList({
                pageSize: 4
            });
            if (result.code === 200) {
                this.GOData = result.data

            } else {
                this.$message({
                    message: '暂无数据。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },
        async getNewsPrevious() {
            const result = await this.$http.home.getNewsPrevious({
                pageSize: 4
            });
            if (result.code === 200) {
                this.ReviewData = result.data

            } else {
                this.$message({
                    message: '暂无数据。。。',
                    type: 'error',
                    center: true
                })
                return
            }
        },
        // async getUserIndexList() {
        //     const result = await this.$http.home.getUserIndexList({
        //         pageSize: 4
        //     })
        //     if (result.code === 200) {
        //         this.merchants = result.data;
        //     } else {
        //         this.$message({
        //             message: '暂无数据。。。',
        //             type: 'error',
        //             center: true
        //         })
        //         return
        //     }
        // }
       
    }
}
</script>

<style lang="less">
.home-wrap {
    // margin-top: 210px;
    height: 100vh;
    width: 100vw;
    .honest-man {
        width: 100%;

        .merchants-wrap {
            width: 100%;
            font-size: 28px;
            padding: 0 20px;

            .merchants {
                height: 240px;
                display: flex;
                border-bottom: 0.013333rem dashed #e1e1e1;
                padding: 20px 0;

                .img-wrap {
                    height: 184px;
                    width: 35%;
                    margin-right: 20px;
                    border: 1px solid #e1e1e1;

                    img {
                        width: 100%;
                        height: 180px;

                    }
                }

                .merchants-text {
                    height: 180px;
                    align-items: center;

                    .datailsWrap {
                        margin-top: 30px;

                        .honesDetailsItem {
                            margin-top: 6px;
                            font-size: 28px;
                        }
                    }

                }
            }

        }
    }
}
</style>
